import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Admin pages show the public favicon rotated 180°; everything else keeps the original files.
const ICONS = {
  'favicon.ico': 'favicon-admin.ico',
  'favicon-32.png': 'favicon-admin-32.png',
  'favicon-16.png': 'favicon-admin-16.png',
};
const VERSION = 'v=2';

export default function FaviconSwitcher() {
  const { pathname } = useLocation();
  const admin = pathname === '/admin' || pathname.startsWith('/admin/');

  useEffect(() => {
    document.querySelectorAll('link[rel~="icon"]').forEach((el) => {
      const current = (el.getAttribute('href') || '').split('?')[0];
      const file = current.split('/').pop();
      const original = Object.keys(ICONS).find((k) => k === file || ICONS[k] === file);
      if (!original) return;
      el.setAttribute('href', `/${admin ? ICONS[original] : original}?${VERSION}`);
    });
  }, [admin]);

  return null;
}
